import { atom } from 'jotai';
import type { Logger } from '../..';
export const loggerAtom = atom<Logger>();